module.exports = __webpack_public_path__ + "static/media/caia.0b4566ec.jpeg";